import React, { useEffect } from "react";
import { Platform, View, Text } from "react-native";
let SvgUri;
if (Platform.OS !== 'web') {
    SvgUri = require('react-native-svg').SvgUri;
}
import LottieView from "lottie-react-native";
const ManageLimitLanding = ({ height, switchingResponse, switchedTo }) => {
    const [lottie, setLottie] = React.useState(require('../../lottie/assets/account_switch_loader.json'));
    const [title, setTitle] = React.useState("Switching loan accounts...");
    useEffect(() => {
        if (switchingResponse === "SUCCESS") {
            setLottie(require('../../lottie/assets/account_switch_success.json'));
            setTitle("Switched to " + (switchedTo ? switchedTo : "loan account"));
        }
        else if (switchingResponse === "FAILURE") {
            setLottie(require('../../lottie/assets/account_switch_failure.json'));
            setTitle("Failed to switch loan accounts");
        }
    }, [switchingResponse]);
    return (React.createElement(View, { style: { flex: 1, marginHorizontal: -16, height: height, marginTop: 250, justifyContent: 'center', alignItems: 'center' } },
        React.createElement(LottieView, { source: lottie, style: { width: 150, height: 150 }, autoPlay: true, loop: true }),
        React.createElement(Text, { style: { color: "#152130", fontSize: 14, fontWeight: "600", lineHeight: 20 } }, title)));
};
export default (ManageLimitLanding);
